import { Component } from '@headless-workspace/typings';

export const ResultSection: Component = () => {
    return (
        <section id={'product-list-result'} className={'px-1 py-0.5'}>
            <div className={'bg-background-skeleton'}>Results</div>
        </section>
    );
};
